import React from "react";
import moment from "moment-jalaali";
import * as search from "../../SearchPage/_redux/searchRedux";
import { injectIntl } from "react-intl";
import { connect, shallowEqual, useDispatch } from "react-redux";
import { search_travel } from "../_redux/searchCrud";
import { useHistory } from "react-router-dom";
import { useSelector } from "../../../utils/react-redux-hooks";
import SearchSectionSearchWidget from "../../Homepage/pages/widgets/components/SearchSectionSearchWidget";
import SearchSectionBody from "../../Homepage/pages/widgets/components/searchSectionBody";
import PriceAndTimeFilter from "../../Homepage/pages/widgets/components/PriceAndTimeFilter";
import MobileNotificationAndHeader from "../../Homepage/pages/widgets/components/MobileNotificationAndHeader";
import { actions } from "../../ReservePage/_redux/reserveRedux";
import { Loop } from "@material-ui/icons";
import { Dialog, Button } from "@material-ui/core";

function Search(props) {
  
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const history = useHistory();
  let { state } = useSelector(
    (state) => ({
      state: state.search,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  React.useEffect(() => {
    setTimeout(() => {
      handleOpen();
    }, 600000);
  }, []);

  React.useEffect(() => {
    dispatch(actions.setLoadingStats(undefined));
    const seatCount = props.count.split(",");
    const count = Number(seatCount[0]) + Number(seatCount[1]);
    search_travel(props.source_id, props.dest_id, props.date, count)
      .then((data) => {
        props.loadTravels(data.data.data);
        props.setFilteredTravels(data.data.data);
        dispatch(actions.setMockTravels(data.data.data));
        if (data.data.data.length === 0) {
          dispatch(actions.setLoadingStats("0"));
        } else {
          dispatch(actions.setLoadingStats("1"));
        }
      })
      .catch(function (error) {
        props.serverErrorOccurred(error);
        dispatch(actions.setLoadingStats("-1"));
        dispatch(actions.setMockTravels([]));
      });
  }, []);

  if (state === undefined) state = {};
  moment.loadPersian({ dialect: "persian-modern" });
  // if (state.is_results_ready === false) {
  //   if (state.round_trip_info_1 === null) {
  //     let date = state.departure_date;
  //     if (date === null) {
  //       date = props.date;
  //     } else {
  //       date = date.year + "-" + date.month + "-" + date.day;
  //       date = moment(date, "jYYYY-jMM-jD").format("YYYY-MM-D");
  //     }
  //     search_travel(props.source_id, props.dest_id, props.date)
  //       .then((data) => {
  //         props.loadTravels(data.data.Data);
  //       })
  //       .catch(function(error) {
  //         props.serverErrorOccurred(error);
  //       });
  //   } else {
  //     let date = props.date2;
  //     search_travel(props.dest_id, props.source_id, props.date2)
  //       .then((data) => {
  //         props.loadTravels(data.data.data);
  //       })
  //       .catch(function(error) {
  //         props.serverErrorOccurred(error);
  //       });
  //   }
  // }

  let day_string = moment(props.date).format("dddd jD jMMMM");
  let day2_string = "";
  if (props.date2 !== null)
    day2_string = moment(props.date2).format("dddd jD jMMMM");

  function timeRangeValueLabelFormat(value) {
    const hour = Math.round(value / 60);
    const minutes = value % 60;
    return `${hour.toLocaleString("fa-IR", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}:${minutes.toLocaleString("fa-IR", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}`;
  }

  let tomorrow_date = moment(props.date, "YYYY-M-D")
    .add(1, "days")
    .format("YYYY-M-D");
  let tomorrow_url =
    "/bus-ticket/" + tomorrow_date + "/" + props.source_id + "/" + props.dest_id;
  let yesterday_date = moment(props.date, "YYYY-M-D")
    .subtract(1, "days")
    .format("YYYY-M-D");
  let yesterday_url =
    "/bus-ticket/" + yesterday_date + "/" + props.source_id + "/" + props.dest_id;

  function handleDayChange(day, url) {
    {
      let d2 = moment(day, "YYYY-M-D").format("jYYYY-jM-jD");
      d2 = d2.split("-");
      d2 = {
        year: parseInt(d2[0]),
        month: parseInt(d2[1]),
        day: parseInt(d2[2]),
      };
      props.changeCurrentDay(d2, props.source_id, props.dest_id);
      history.push(url);
    }
    return undefined;
  }

  const set_round_trip_info = (trip_info) => {
    if (state.round_trip_info_1 === null) {
      props.handle_variables("round_trip_info_1", trip_info);
      props.handle_variables("is_results_ready", false);
    } else {
      props.handle_variables("round_trip_info_2", trip_info);
      //TODO:Go To next page
    }
  };


  return (
    <div>
      {/* begin::Dashboard */}
      <Dialog
        open={open}
        onClose={handleClose}
        keepMounted
        className="p-10"
        PaperProps={{ style: { maxHeight: "unset" } }}
        disableBackdropClick
      >
        <div className="row container mx-auto p-4">
          <div className="col-12 d-flex justify-content-center">
            <Loop
              className="col-6"
              style={{
                fontSize: "10rem",
                color: "#6dd06d",
                transform: "rotate(90deg)",
              }}
            />
          </div>
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ gap: 10 }}
          >
            <h1 className="text-dark">
              {" "}
              <b>صفحه خود را بروزرسانی کنید</b>
            </h1>
            <h6
              className="container mt-5 mb-3"
              style={{ lineHeight: "30px", color: "#4c4b4b" }}
            >
              ممکن است اطلاعات نشان داده شده معتبر نباشد, برای اطمینان از
              اطلاعات نمایش داده شده صفحه را بروزرسانی کنید.
            </h6>
            <div className="row container">
              <div
                className="col-12 my-2 col-md-6 p-1"
                style={{ height: "4rem" }}
              >
                <Button
                  className="w-100 h-100"
                  style={{
                    backgroundColor: "#6dd06d",
                    border: "0.5px solid white",
                    borderRadius: "13px",
                  }}
                  onClick={() => {
                    handleClose();
                    dispatch(actions.setLoadingStats(undefined));
                    console.log("Sss",props);
                    search_travel(props.source_id, props.dest_id, props.date)
                      .then((data) => {
                        props.loadTravels(data.data.data);
                        props.setFilteredTravels(data.data.data);
                        dispatch(actions.setMockTravels(data.data.data));
                        if (data.data.data.length === 0) {
                          dispatch(actions.setLoadingStats("0"));
                        } else {
                          dispatch(actions.setLoadingStats("1"));
                        }
                      })
                      .catch(function (error) {
                        props.serverErrorOccurred(error);
                        dispatch(actions.setLoadingStats("-1"));
                        dispatch(actions.setMockTravels([]));
                      });
                  }}
                >
                  <h6 className="mx-auto my-auto text-white">
                    بروزرسانی جست و جو
                  </h6>
                </Button>
              </div>
              <div
                className="col-12 my-2 col-md-6 p-1"
                style={{ height: "4rem" }}
              >
                <Button
                  className="w-100 h-100 bg-white"
                  style={{
                    border: "0.5px solid #6dd06d",

                    borderRadius: "13px",
                  }}
                  onClick={() => {
                    history.push("/");
                  }}
                >
                  <h6 className="mx-auto my-auto " style={{ color: "#6dd06d" }}>
                    بازگشت به صفحه اصلی
                  </h6>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      {/* begin::Row */}
      <div className="row flex-column d-md-none">
        <MobileNotificationAndHeader 
          source_id={props.source_id}
          dest_id={props.dest_id}
          date={props.date}
          date2={props.date2}
          count={props.count}
        />        
      </div>
      <div className="row d-none d-md-block">
        <SearchSectionSearchWidget
          source_id={props.source_id}
          dest_id={props.dest_id}
          date={props.date}
          date2={props.date2}
          count={props.count}
          className="gutter-b"
          widgetHeight="150px"
        />
      </div>
      <SearchSectionBody
        source_id={props.source_id}
        dest_id={props.dest_id}
        date={props.date}
        date2={props.date2}
        count={props.count}
      />
    </div>
  );
}

export default injectIntl(connect(null, search.actions)(Search));
